module.exports = "/_next/static/images/7ef995cd9a473839cc98e94de4099fcd-mockup-transfer@0.5x.jpg.webp";